import React from 'react';
import ContainerBody from '@components/ContainerBody';
import Breadcrumb from '@components/Breadcrumb';
import DMAList from './components/DMAList';
import { usePermission } from '@contexts/Auth/UsePermission';
import Page403 from '@page/Common/403/403';

const DMAPage = () => {
  const { dma } = usePermission();

  if (!dma?.view) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[{ name: 'Quản lý DMA', path: '/customers/dma' }]}
        />
      </div>
      <DMAList />
    </ContainerBody>
  );
};

export default DMAPage;
